<app-page-header
  [pageTitle]="'Zonas'"
  [showCreateButton]="permissionAuth.canCreate('zonas')"
  [textButton]="'Nueva zona'"
  (onCreateClick)="create()"
/>

<app-data-table
  [columns]="columns"
  [data]="zonas"
  [loading]="loading"
  (rowClick)="edit($event.item.id)"
>
  <ng-template appTableCell="ciudad" let-item>
    {{ getCiudad(item) }}
  </ng-template>
  <ng-template appTableCell="departamento" let-item>
    {{ getDepartamento(item) }}
  </ng-template>
  <ng-template appTableCell="pais" let-item>
    {{ getPais(item) }}
  </ng-template>
  <ng-template appTableCell="acciones" let-item>
    <app-delete-trigger *hasPermission="'zonas:delete'"
      [title]="'Eliminar zona'"
      [subtitle]="'¿Está seguro de eliminar esta zona? Esta acción no se puede deshacer.'"
      (clickDeleteEvent)="delete(item.id)"
    />
  </ng-template>
</app-data-table>

<app-pagination
  [currentPage]="currentPage"
  [lastPage]="lastPage"
  [perPage]="perPage"
  [total]="total"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
/>
